// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminEventFormController from "./admin_event_form_controller"
application.register("admin-event-form", AdminEventFormController)

import AdminMapController from "./admin_map_controller"
application.register("admin-map", AdminMapController)

import AdminShellController from "./admin_shell_controller"
application.register("admin-shell", AdminShellController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import CsvDropzoneController from "./csv_dropzone_controller"
application.register("csv-dropzone", CsvDropzoneController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import EventMapController from "./event_map_controller"
application.register("event-map", EventMapController)

import FavouriteWalksController from "./favourite_walks_controller"
application.register("favourite-walks", FavouriteWalksController)

import FavouritesController from "./favourites_controller"
application.register("favourites", FavouritesController)

import FeaturedImpressionController from "./featured_impression_controller"
application.register("featured-impression", FeaturedImpressionController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import GuideMapController from "./guide_map_controller"
application.register("guide-map", GuideMapController)

import GuideNavController from "./guide_nav_controller"
application.register("guide-nav", GuideNavController)

import GuideRestController from "./guide_rest_controller"
application.register("guide-rest", GuideRestController)

import GuideSearchController from "./guide_search_controller"
application.register("guide-search", GuideSearchController)

import GuideTabsController from "./guide_tabs_controller"
application.register("guide-tabs", GuideTabsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HoursPickerController from "./hours_picker_controller"
application.register("hours-picker", HoursPickerController)

import ImageProgressController from "./image_progress_controller"
application.register("image-progress", ImageProgressController)

import ImageQueueController from "./image_queue_controller"
application.register("image-queue", ImageQueueController)

import ImportFilterController from "./import_filter_controller"
application.register("import-filter", ImportFilterController)

import MailingListController from "./mailing_list_controller"
application.register("mailing-list", MailingListController)

import MapController from "./map_controller"
application.register("map", MapController)

import NewEventController from "./new_event_controller"
application.register("new-event", NewEventController)

import PlanController from "./plan_controller"
application.register("plan", PlanController)

import PullRefreshController from "./pull_refresh_controller"
application.register("pull-refresh", PullRefreshController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ScopeGroupsController from "./scope_groups_controller"
application.register("scope-groups", ScopeGroupsController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SlideMenuController from "./slide_menu_controller"
application.register("slide-menu", SlideMenuController)

import SubmissionFormController from "./submission_form_controller"
application.register("submission-form", SubmissionFormController)

import SubmissionMethodController from "./submission_method_controller"
application.register("submission-method", SubmissionMethodController)

import SubmitStepsController from "./submit_steps_controller"
application.register("submit-steps", SubmitStepsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TodoController from "./todo_controller"
application.register("todo", TodoController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import WalkAdditionsController from "./walk_additions_controller"
application.register("walk-additions", WalkAdditionsController)

import WalkMapController from "./walk_map_controller"
application.register("walk-map", WalkMapController)

import WalkNoteController from "./walk_note_controller"
application.register("walk-note", WalkNoteController)

import WalkShareController from "./walk_share_controller"
application.register("walk-share", WalkShareController)

import WalkThumbnailController from "./walk_thumbnail_controller"
application.register("walk-thumbnail", WalkThumbnailController)

import WelcomePopupController from "./welcome_popup_controller"
application.register("welcome-popup", WelcomePopupController)
